import { useMutation } from '@tanstack/react-query';
import { useToast } from '@/hooks/use-toast';
import {
  solicitarRecuperacaoSenha,
  validarTokenSenha,
  redefinirSenha,
  reenviarConvite,
} from '../api/AuthApi';
import type {
  SolicitarRecuperacaoSenhaApi,
  ValidarTokenSenhaApi,
  RedefinirSenhaApi,
  ReenviarConviteApi,
} from '../types';

/**
 * Sem toast nas três de senha: as telas (`RecuperarSenha`, `RedefinirSenha`)
 * têm estados próprios (confirmação, link inválido) e controlam a mensagem
 * na tela mesmo — um toast por cima seria redundante. `useReenviarConvite` é
 * diferente: é uma ação de lista (`GestaoUsuariosTab`), no mesmo padrão dos
 * outros mutations de `useConfiguracoes`.
 */

export function useSolicitarRecuperacaoSenha() {
  return useMutation({
    mutationFn: (model: SolicitarRecuperacaoSenhaApi) => solicitarRecuperacaoSenha(model),
  });
}

export function useValidarTokenSenha() {
  return useMutation({
    mutationFn: (model: ValidarTokenSenhaApi) => validarTokenSenha(model),
  });
}

export function useRedefinirSenha() {
  return useMutation({
    mutationFn: (model: RedefinirSenhaApi) => redefinirSenha(model),
  });
}

export function useReenviarConvite() {
  const { toast } = useToast();

  return useMutation({
    mutationFn: (model: ReenviarConviteApi) => reenviarConvite(model),
    onSuccess: response => {
      if (response.status.resultado) {
        toast({ title: 'Convite reenviado.' });
      } else {
        toast({ variant: 'destructive', title: response.status.mensagem });
      }
    },
    onError: () => {
      toast({ variant: 'destructive', title: 'Erro ao reenviar convite.' });
    },
  });
}
